import React, { useState, useEffect } from "react";
import '../styles/Turismo.css';

/*Atractivos Turisticos de Santo Tomas*/
import Catedral_foto_01 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/catedral_01.jpg';
import Catedral_foto_02 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/catedral_02.jpg';
import Catedral_foto_03 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/catedral_03.jpg';
import Wamanmarka_foto_01 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/wamanmarka_01.jpg';
import Wamanmarka_foto_02 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/wamanmarka_02.jpg';
import Wamanmarka_foto_03 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/wamanmarka_03.jpg';
import VColca_foto_01 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/Vcolca_01.jpg';
import VColca_foto_02 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/Vcolca_02.jpg';
import VColca_foto_03 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/Vcolca_03.jpg';
import Chucchu_foto_01 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/chucchu_01.jpg';
import Chucchu_foto_02 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/chucchu_02.jpg';
import Chucchu_foto_03 from '../imagenes/atractivosTuristicos/SANTO_TOMAS/chucchu_03.jpg';

/*Atractivos Turisticos de Livitaca*/
import Warari_foto_01 from '../imagenes/atractivosTuristicos/LIVITACA/Warari_01.jpg';
import Warari_foto_02 from '../imagenes/atractivosTuristicos/LIVITACA/Warari_02.jpg';
import Warari_foto_03 from '../imagenes/atractivosTuristicos/LIVITACA/Warari_03.jpg';
import Chinisiri_foto_01 from '../imagenes/atractivosTuristicos/LIVITACA/Chinisiri_01.jpg';
import Chinisiri_foto_02 from '../imagenes/atractivosTuristicos/LIVITACA/Chinisiri_02.jpg';
import Chinisiri_foto_03 from '../imagenes/atractivosTuristicos/LIVITACA/Chinisiri_03.jpg';

/*Atractivos Turisticos de Chamaca*/
import Toqra_foto_01 from '../imagenes/atractivosTuristicos/CHAMACA/Toqra_01.png';
import Toqra_foto_02 from '../imagenes/atractivosTuristicos/CHAMACA/Toqra_02.png';
import Toqra_foto_03 from '../imagenes/atractivosTuristicos/CHAMACA/Toqra_03.jpg';

/*Atractivos Turisticos de Chamaca*/
import Tuntumapata_foto_01 from '../imagenes/atractivosTuristicos/VELILLE/Tuntumapata_01.jpg';
import Tuntumapata_foto_02 from '../imagenes/atractivosTuristicos/VELILLE/Tuntumapata_02.png';
import Tuntumapata_foto_03 from '../imagenes/atractivosTuristicos/VELILLE/Tuntumapata_03.png';

/*Atractivos Turisticos de Llusco*/
import Waninqaqa_foto_01 from '../imagenes/atractivosTuristicos/LLUSCO/Waninqaqa_01.png';
import Waninqaqa_foto_02 from '../imagenes/atractivosTuristicos/LLUSCO/Waninqaqa_02.jpg';
import Waninqaqa_foto_03 from '../imagenes/atractivosTuristicos/LLUSCO/Waninqaqa_03.jpg';

/*Atractivos Turisticos de Colquemarca*/
import Ccacansa_foto_01 from '../imagenes/atractivosTuristicos/COLQUEMARCA/Ccacansa_01.jpg';
import Ccacansa_foto_02 from '../imagenes/atractivosTuristicos/COLQUEMARCA/Ccacansa_02.jpg';
import Ccacansa_foto_03 from '../imagenes/atractivosTuristicos/COLQUEMARCA/Ccacansa_03.jpg';

/*Atractivos Turisticos de Capacmarca*/
import Rumichaca_foto_01 from '../imagenes/atractivosTuristicos/CAPACMARCA/Rumichaca_01.png';
import Rumichaca_foto_02 from '../imagenes/atractivosTuristicos/CAPACMARCA/Rumichaca_02.png';
import Rumichaca_foto_03 from '../imagenes/atractivosTuristicos/CAPACMARCA/Rumichaca_03.png';
/**/
const DATA = [
  {
    id: 1,
    distrito: 'Santo Tomas', 
    nombre: 'Iglesia de Santo Tomas',
    imagen: Catedral_foto_01,
    descripcion: 'Una hermosa construcción arquitectónica de planta en cruz latina, mandada a realizarse por el párroco Manuel de Boza Irarrazabal de ascendencia Chilena, dueño de las minas de plata de Huanso en el año de 1787 y finalizada en el año de 1789 siendo el constructor el maestro Pedro Regalado Zegarra.',
    fotos: [
      Catedral_foto_02,
      Catedral_foto_03,
    ],
    video: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    ubicacion: 'https://www.google.com/maps?q=Malecón+Bertolotto,+San+Miguel,+Lima'
  },
  {
    id: 2,
    distrito: 'Santo Tomas',
    nombre: 'Centro Arqueológico de Wamanwarka',
    imagen: Wamanmarka_foto_01,
    descripcion: 'A 30 min. Del centro de la población de Santo Tomás se encuentra el centro arqueológico de Wamanmarka construido por plazas circulares aterrazadas, recintos de plantas rectangulares con presencia de nichos interiores, cementerios, intiwatana, cerámica, morteros.',
    fotos: [
      Wamanmarka_foto_02,
      Wamanmarka_foto_03,
    ],
    video: 'https://www.youtube.com/embed/kXYiU_JCYtU',
    ubicacion: 'https://www.google.com/maps?q=Parque+del+Amor,+Miraflores,+Lima'
  },
  {
    id: 3,
    distrito: 'Santo Tomas',
    nombre: 'Valle de Colca',
    imagen: VColca_foto_01,
    descripcion: 'El valle de Colca está ubicado a 20 minutos de la plaza de Santo Tomás, colindante con el distrito de Llusco, es un lugar cálido y verdoso, el río que se encuentra en este lugar del mismo nombre es ideal para practicar canotaje. Cada 23 de septiembre por motivos de celebrarse el día del estudiante se suele visitar este lugar con todos los estudiantes de las Instituciones de Santo Tomás para poder pasar un día de campo.',
    fotos: [
      VColca_foto_02,
      VColca_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  },
  {
    id: 4,
    distrito: 'Santo Tomas',
    nombre: 'Aguas Termales Chucchu',
    imagen: Chucchu_foto_01,
    descripcion: 'Las aguas termales de Chukchu se encuentra a 35 minutos de la plaza de santo Tomás en la región natural de suni según Vidal Pulgar a una altura de 3800 msnm. aproximadamente, las aguas tienen propiedades curativas, razón por lo cual personas de todas partes de esta región recurren a los baños termales de chukchu, su temperatura es aproximadamente de 60° C, el caudal es considerable y se encuentra en la orilla del afluyente al río santo Tomás.',
    fotos: [
      Chucchu_foto_02,
      Chucchu_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  },
  {
    id: 5,
    distrito: 'Livitaca',
    nombre: 'Grutas de Warari',
    imagen: Warari_foto_01,
    descripcion: 'Warari esta ubicado en el distrito de Livitaca, aproximadamente a 3 horas de Santo Tomás, capital de la provincia de Chumbivilcas, se encuentra a 3450 msnm. En todo el trayecto en su interior de la gruta se puede observar Estalactitas de forma y estilo caprichoso, colgando del techo de dicha caverna, también podemos hallar estalagmitas que gracias al goteo se han formado monumentales obras solidas de forma caprichosa.',
    fotos: [
      Warari_foto_02,
      Warari_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  },
  {
    id: 6,
    distrito: 'Livitaca',
    nombre: 'Cañon de Chiñisiri',
    imagen: Chinisiri_foto_01,
    descripcion: 'El Cañón de Chiñisiri o Valle de los muertos está ubicada dentro de los territorios de la comunidad de Unión Ccora en el Distrito de Livitaca (al norte del Distrito), a 3723 m.s.n.m. , donde podemos encontrar una necrópolis pre hispánica(chullpas) en todo su recorrido y una serie de curiosas formaciones rocosas de formación natural.',
    fotos: [
      Chinisiri_foto_02,
      Chinisiri_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  },
  {
    id: 7,
    distrito: 'Chamaca',
    nombre: 'Ruinas de Toqra',
    imagen: Toqra_foto_01,
    descripcion: 'En el distrito de Chamaca, hallamos las ruinas de Toqra. Aunque se desconoce su origen, los pobladores mantienen en su memoria la historia de este lugar construído en los tiempos del Imperio Inca.',
    fotos: [
      Toqra_foto_02,
      Toqra_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  },
  {
    id: 8,
    distrito: 'Velille',
    nombre: 'Ruinas de Tuntumapata',
    imagen: Tuntumapata_foto_01,
    descripcion: 'Tuntumapata es uno de esos paisajes con una esencia especial. Algunos le llaman el rincón de “las piedras dormidas” o “las piedras cansadas” que se quedaron a medio camino entre Alccavictoria y Cusco. Son varias las leyendas que nos hablan de este peculiar jardín de piedra localizado en el rico Velille.',
    fotos: [
      Tuntumapata_foto_02,
      Tuntumapata_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  },
  {
    id: 9,
    distrito: 'Llusco',
    nombre: 'Waninqaqa',
    imagen: Waninqaqa_foto_01,
    descripcion: 'El Sitio Arqueológico Waninqaqa (también conocido como Wininkacca) se encuentra en el distrito de Llusco, provincia de Chumbivilcas, Cusco. Es un impresionante complejo funerario prehispánico edificado en un abrigo rocoso, caracterizado por su arquitectura de piedra y barro, así como por la presencia de restos óseos humanos que evidencian antiguas prácticas mortuorias.',
    fotos: [
      Waninqaqa_foto_02,
      Waninqaqa_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  },
  {
    id: 10,
    distrito: 'Colquemarca',
    nombre: 'Laguna de Ccacansa',
    imagen: Ccacansa_foto_01,
    descripcion: 'La laguna Ccaccansa está ubicado en la comunidad campesina de Huaracco, del distrito de Colquemarca, a 4646 m.s.n.m., aproximadamente a 2 horas de Santo Tomás, capital de la provincia de Chumbivilcas. En esta laguna se pueden realizar diferentes actividades como paseo en bote, pesca y avistamiento de la fauna silvestre, además de degustar de los platos típicos de la zona, a base de trucha recién extraída de la laguna.',
    fotos:[  
      Ccacansa_foto_02,
      Ccacansa_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  },
  {
    id: 11,
    distrito: 'Ccapacmarca',
    nombre: 'Rumichaca',
    imagen: Rumichaca_foto_01,
    descripcion: '"Rumichaca" se refiere a un puente natural de piedra en la frontera entre Colombia y Ecuador, mientras que "Capacmarca" es un distrito en la provincia de Chumbivilcas, en la región de Cusco, Perú. Aunque se trata de dos lugares geográficos diferentes.',
    fotos:[  
      Rumichaca_foto_02,
      Rumichaca_foto_03,
    ],
    video: 'https://www.youtube.com/embed/2vjPBrBU-TM',
    ubicacion: 'https://www.google.com/maps?q=Puente+de+los+Suspiros,+Barranco,+Lima'
  }
];

function Turismo() {
  const [filtro, setFiltro] = useState('Todos');
  const [busqueda, setBusqueda] = useState('');
  const [modal, setModal] = useState(null);
  const [fotoIndex, setFotoIndex] = useState(0);

  // Carrusel automático
    useEffect(() => {
      if (modal) {
        const interval = setInterval(() => {
          setFotoIndex((prev) => (prev + 1) % modal.fotos.length);
        }, 10000);
        return () => clearInterval(interval);
      }
    }, [modal]);

  const distritos = ['Todos', ...new Set(DATA.map(item => item.distrito))];

  const filtrados = DATA.filter(item => {
    const coincideDistrito = filtro === 'Todos' || item.distrito === filtro;
    const coincideBusqueda = item.nombre.toLowerCase().includes(busqueda.toLowerCase());
    return coincideDistrito && coincideBusqueda;
  });

  const cambiarFoto = (direccion) => {
    if (!modal) return;
    const total = modal.fotos.length;
    setFotoIndex((prev) => (prev + direccion + total) % total);
  };

  return (
    <div className="turismo-container">
      <h2 className="titulo">Atractivos Turísticos de la Provincia de Chumbivilcas</h2>

      <div className="busqueda">
        <input
          type="text"
          placeholder="Buscar atractivo turístico..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </div>

      <div className="filtros">
        {distritos.map((dist, index) => (
          <button
            key={index}
            className={`boton-filtro ${filtro === dist ? 'activo' : ''}`}
            onClick={() => setFiltro(dist)}
          >
            {dist}
          </button>
        ))}
      </div>

      <div className="grid-turismo">
        {filtrados.map((item) => (
          <div key={item.id} className="card">
            <img src={item.imagen} alt={item.nombre} className="card-img" />
            <div className="card-body">
              <h2>{item.nombre}</h2>
              <p>{item.descripcion}</p>
              <span className="tag">{item.distrito}</span>
              <button className="btn-vermas" onClick={() => setModal(item)}>Ver más</button>
            </div>
          </div>
        ))}
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="cerrar" onClick={() => setModal(null)}>×</button>
            <h2>{modal.nombre}</h2>
            <div className="carousel">
              <button className="nav left" onClick={() => cambiarFoto(-1)}>&#10094;</button>
              <img src={modal.fotos[fotoIndex]} alt="Foto turística" />
              <button className="nav right" onClick={() => cambiarFoto(1)}>&#10095;</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Turismo;
